<!--
 * @Author: 付康 fukang@yuouhui.com
 * @Date: 2022-11-01 14:31:28
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-11-16 09:58:59
 * @FilePath: /wxkn-experience/src/components/MiProlist.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div  class="pro-list">
      <div class="left-list">
        <listItem
          v-for="item in leftArray"
          :key="item.id"
          :noteData="item"
          @removeRequireAction="removeRequireAction"
          @shareAction="shareAction"
        ></listItem>
      </div>
      <div class="right-list">
        <listItem
          v-for="item in rightArray"
          :key="item.id"
          :noteData="item"
          @shareAction="shareAction"
        ></listItem>
      </div>
    </div>
  </template>

<script>
    import listItem from "./MiListItem";
    export default {
        data() {
            return {

            };
        },
        props: {
            list: {
                typeof: Array,
                default: () => [],
            },
        },
        mounted() {},
        computed: {
            leftArray() {
                let arr = [];
                for (let i = 0; i < this.list.length; i++) {
                    if (i % 2 == 0) {
                        arr.push(this.list[i]);
                    }
                }
                return arr;
            },
            rightArray() {
                let arr = [];
                for (let i = 0; i < this.list.length; i++) {
                    if (i % 2 != 0) {
                        arr.push(this.list[i]);
                    }
                }
                return arr;
            },
        },
        components: {
            listItem,
        },
        methods: {
            shareAction(){
                this.$emit("shareAction");
            },
            removeRequireAction(e) {
                // let index = this.rightArray.findIndex(
                //   (item) =>
                //     item.type == "REQUIRE" && item.requireVo && item.requireVo.id == e.id
                // );
                // if (index > -1) {

                //   this.$nextTick(()=>{
                //     this.rightArray.splice(index, 1);
                //   })
                //   this.$forceUpdate()
                // }


                // this.$emit("removeRequireAction", e);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .pro-list {
        background: #efefef;
        min-height: 100%;
        width: 100%;
        display: flex;
        // padding: 10px;
        padding-bottom: 100px;
        .left-list {
            margin-right: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/MiProlist.vue